import * as types from './types';

const INITIAL_STATE = {
  report: [],
  reportLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_SPECIAL_MESSAGE_REPORT:
      return { ...state, report: action.payload.data.Data };
    case types.CLEAR_REPORT_DATA:
      return { ...state, report: [] };
    case types.SPECIAL_MESSAGE_REPORT_LOAD:
      return { ...state, reportLoading: action.payload };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/specialmessage/state/reducer.js